import { useState } from "react";
import { faqs } from "@/mocks/content";

export default function Faq() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto w-full max-w-3xl px-4 md:px-6">
        <div className="mb-10 text-center">
          <span className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-600">
            <i className="ri-question-line"></i>
            常见问题
          </span>
          <h2 className="mt-2 font-heading text-3xl text-foreground-950 md:text-4xl">
            你可能想问的都在这里
          </h2>
        </div>

        <div className="flex flex-col gap-3">
          {faqs.map((f, i) => {
            const isOpen = open === i;
            return (
              <div
                key={f.q}
                className="overflow-hidden rounded-lg border border-background-200/80 bg-background-50"
              >
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? null : i)}
                  className="flex w-full items-center justify-between gap-3 px-5 py-4 text-left"
                >
                  <span className="text-sm font-medium text-foreground-950 md:text-base">{f.q}</span>
                  <i
                    className={
                      isOpen
                        ? "ri-arrow-up-s-line flex h-6 w-6 items-center justify-center text-xl text-primary-600"
                        : "ri-arrow-down-s-line flex h-6 w-6 items-center justify-center text-xl text-foreground-600"
                    }
                  ></i>
                </button>
                {isOpen && (
                  <div className="px-5 pb-5 text-sm leading-relaxed text-foreground-700">{f.a}</div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}